import cn from 'classnames';

import { defineTheme, ThemeKeys } from 'js/utils/theme-helpers';

import NumberBlock from 'components/number-block/NumberBlock';

import { INumberListBlock } from 'source/NFR.types';

const themes = defineTheme({
  twoColumns: 'number-list-block--theme-two-columns',
  threeColumns: 'number-list-block--theme-three-columns'
});
type Theme = ThemeKeys<typeof themes>;

interface NumberListBlockProps extends INumberListBlock {
  theme?: Theme | Theme[];
}

const NumberListBlock: React.FC<NumberListBlockProps> = ({ numbers, theme }) => (
  <div className={cn('number-list-block', themes(theme))}>
    {numbers?.map(numb => (
      <NumberBlock key={numb.number} {...numb} />
    ))}
  </div>
);

NumberListBlock.displayName = 'NumberListBlock';

export default NumberListBlock;
